module.exports = __webpack_public_path__ + "static/media/ribbon.b2aef401.ogg";